module.exports = __webpack_public_path__ + "img/Logo_4xOney_RGB_verde.a17a3850.svg";